module.exports = __webpack_public_path__ + "public/a7c7b72fabf704b62a1534f07114362e.woff";